import {BelegDTO, GeschaeftskundendatenDTO, KundendatenDTO, PrivatkundendatenDTO} from '../openapi/fakturierung-openapi';
import {Belegart} from './belegart.enum';


export function isGeschaeftskundendaten(obj: KundendatenDTO): obj is GeschaeftskundendatenDTO {
  return (obj as GeschaeftskundendatenDTO).typ == 'Geschaeftskundendaten';
}

export function isPrivatkundendaten(obj: KundendatenDTO): obj is PrivatkundendatenDTO {
  return (obj as PrivatkundendatenDTO).typ == 'Privatkundendaten';
}

export function isRechnung(belegart?: string | Belegart): belegart is string {
  if (!belegart) return false;
  return belegart?.toLowerCase() === Belegart.Rechnung.toLowerCase();
}

export function isGutschrift(belegart?: string | Belegart): belegart is string {
  if (!belegart) return false;
  return belegart?.toLowerCase() === Belegart.Gutschrift.toLowerCase();
}

export function isLieferschein(belegart?: string | Belegart): belegart is string {
  if (!belegart) return false;
  return belegart?.toLowerCase() === Belegart.Lieferschein.toLowerCase();
}

export function isBelegart(value?: string): value is Belegart {
  if (!value) return false;
  return Object.values(Belegart).some(belegart => belegart.toLowerCase() === value.toLowerCase());
}

/**
 * Ein Lieferschein kann an eine Rechnung uebergeben werden, sobald er
 * festgeschrieben und noch keiner Rechnung zugeordnet ist.
 */
export function canCreateRechnung(beleg?: BelegDTO): boolean {
  return !!beleg
    && isLieferschein(beleg.belegart)
    && !!beleg.status.festgeschrieben
    && !beleg.status.zuRechnungUebergeben;
}

/**
 * Das Stornieren erzeugt nur bei Rechnung und Gutschrift einen Korrekturbeleg;
 * beim Lieferschein ist es ein reiner Statuswechsel.
 */
export function stornoErzeugtKorrekturbeleg(beleg?: BelegDTO): boolean {
  return !!beleg
    && (isRechnung(beleg.belegart) || isGutschrift(beleg.belegart));
}

/**
 * Ein Beleg kann storniert werden, solange er festgeschrieben und nicht bereits
 * storniert ist. Ein an eine aktive Rechnung uebergebener Lieferschein ist
 * ausgenommen.
 */
export function canStorno(beleg?: BelegDTO): boolean {
  return !!beleg
    && !!beleg.status.festgeschrieben
    && !beleg.status.storniert
    && !beleg.status.zuRechnungUebergeben;
}

/** Die B2G-Referenzfelder gibt es nur bei der Rechnung an einen Geschäftskontakt. */
export function hatReferenzfelder(belegart?: string | Belegart, kundendaten?: KundendatenDTO): boolean {
  return isRechnung(belegart) && !!kundendaten && isGeschaeftskundendaten(kundendaten);
}
